import { useState, useMemo, useCallback, useEffect } from 'react';
import { ROWS_PER_PAGE } from '../constants';

export const usePagination = <T>(items: T[], searchTerm: string) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = useMemo(() => {
    return Math.ceil(items.length / ROWS_PER_PAGE);
  }, [items.length]);

  const paginatedItems = useMemo(() => {
    const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
    const endIndex = startIndex + ROWS_PER_PAGE;
    return items.slice(startIndex, endIndex);
  }, [items, currentPage]);

  const handleChangePage = useCallback((_: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  }, []);

  // Сбрасываем страницу при поиске
  useEffect(() => {
    if (searchTerm.length >= 1) {
      setCurrentPage(1);
    }
  }, [searchTerm]);

  return {
    currentPage,
    totalPages,
    paginatedItems,
    handleChangePage,
    setCurrentPage
  };
};

